import type { CustomIconProps } from '../CustomIcon';

export const GlassesIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => (
  <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M3.344 11 8 6c1-1 1.5-1 2-1M20.648 11.008 16 6c-1-1-1.5-1-2-1'
      stroke={secondaryColor}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M10 14a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM22 14a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z' fill={color} />
    <path
      d='M10 14a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm0 0a2 2 0 1 1 4 0m0 0a4 4 0 1 0 8 0 4 4 0 0 0-8 0Z'
      stroke={secondaryColor}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
